import { Stack, Table } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { t } from 'i18next';

import { NoContentPlaceholder } from '@/core/components';

import { Id } from '@/feature/utils';

import { getJournalAisMetricOptions } from './model/JournalQuery';

interface JournalAisMetricTableProps {
  journalId: Id;
}

export function JournalAisMetricTable({ journalId }: JournalAisMetricTableProps) {
  const { data: metrics } = useSuspenseQuery(getJournalAisMetricOptions(journalId));

  return (
    <Stack>
      {metrics.length === 0 && <NoContentPlaceholder title={t('journals.reputation.noData')} />}

      {metrics.length != 0 && (
        <Table>
          <Table.Thead>
            <Table.Tr>
              <Table.Th>
                {t('journals.reputation.articleInfluenceScore.metric.tableHeader.articleInfluenceScore')}
              </Table.Th>
              <Table.Th>{t('journals.reputation.articleInfluenceScore.metric.tableHeader.year')}</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {metrics.map(item => (
              <Table.Tr key={item.id}>
                <Table.Td>{item.articleInfluenceScore}</Table.Td>
                <Table.Td>{item.year}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      )}
    </Stack>
  );
}
